import { ca } from '@cian/analytics';

export function trackClickOnItem(label: string) {
  ca('event', {
    action: 'click_breadcrumbs',
    category: 'card',
    label,
    name: 'oldevent',
  });
}
